import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { SignUp } from '@clerk/clerk-react';
import { useAuth } from '../contexts/AuthContext';
import { useOrganization } from '../contexts/OrganizationContext';
import { AUTH_PROVIDER } from '../config/auth';
import GTMService, { GTMEventName } from '../gtm';
import LocalSignUpForm from '../components/auth/LocalSignUpForm';
import OIDCLoginButton from '../components/auth/OIDCLoginButton';

function SignUpWidget() {
  const redirectUrl = sessionStorage.getItem('redirect_after_auth') || '/organization-setup';
  switch (AUTH_PROVIDER) {
    case 'local':
      return <LocalSignUpForm />;
    case 'oidc':
      // OIDC has no separate sign-up -- users are provisioned by the IdP
      return <OIDCLoginButton />;
    case 'clerk':
    default:
      return <SignUp forceRedirectUrl={redirectUrl} signInUrl='/' />;
  }
}

const SignUpPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const { currentOrganization, isLoading: orgLoading } = useOrganization();

  const hasTrackedPageView = useRef(false);
  useEffect(() => {
    if (hasTrackedPageView.current) return;
    hasTrackedPageView.current = true;
    GTMService.trackPageView(GTMEventName.SIGNUP_PAGE_VIEW);
  }, []);

  // Redirect if already authenticated. Skip when a post-auth redirect is
  // stashed — AppContent consumes that key and navigates there.
  useEffect(() => {
    if (
      isAuthenticated &&
      !sessionStorage.getItem('redirect_after_auth') &&
      !orgLoading &&
      !currentOrganization?.is_demo
    ) {
      navigate('/repositories');
    }
  }, [currentOrganization?.is_demo, isAuthenticated, navigate, orgLoading]);

  return <SignUpWidget />;
};

export default SignUpPage;
